export const HospitalMedicationContainer = {
  minHeight: '100px',
  maxheight: '335px',
  marginTop: '16px',
};
